import { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { Form, StrictDropdownProps } from "semantic-ui-react";
import { getSemanticProps } from "../../util";
import { getUiOptions } from "../../../../utils/getUiOptions";
import { useSchemaTranslation } from "../../../../hooks/useSchemaTranslation";
import { useLoading } from "../../../../../sg-core";
import _debounce from "lodash/debounce";

function RelatedPermitWidget({
  id,
  required,
  readonly,
  disabled,
  name,
  label,
  schema,
  value,
  onChange,
  onBlur,
  onFocus,
  autofocus,
  options,
  formContext,
  uiSchema,
  rawErrors = [],
}: any) {
  const { t } = useSchemaTranslation();

  const permitOptions = ["Tulityölupa 6.8.2021", "Tulityölupa 7.8.2021", "Säiliötyölupa 8.8.2021", "Yleinentyölupa 2021-2022"].map((text, index) => ({ text, value: index }))


  const { placeholder } = getUiOptions(uiSchema) as any;
  const semanticProps = getSemanticProps({ formContext, options });
  // eslint-disable-next-line no-shadow
  const _onChange = ({ target: { value } }: any) =>
    onChange(value === "" ? options.emptyValue : value);
  const _onBlur = () => onBlur && onBlur(id, value);
  const _onFocus = () => onFocus && onFocus(id, value);

  const [query, setQuery] = useState("");
  const { loading, loadError, loadErrored, loadSuccess, startLoading } = useLoading();
  const [results, setResults] = useState<typeof permitOptions>(permitOptions);

  const search = async (query: string) => {
    startLoading();
    setResults([]);
    await new Promise((resolve) => setTimeout(resolve, 400));
    if (query === "error") {
      loadErrored("Failed to fetch results")
    } else {
      loadSuccess();
      setResults(permitOptions.filter((perm) => perm.text.toLowerCase().indexOf(query) > -1))
    };
  };
  const debouncedSearch = useCallback(_debounce(search, 200), [])

  const updateQuery: StrictDropdownProps["onSearchChange"] = (_1, { query }) => {
    setQuery(query);
    debouncedSearch(query)
  };

  return (
    <Form.Select
      label={t(label)}
      value={value}
      loading={loading}
      options={results}
      onSearchChange={updateQuery}
      searchQuery={query}
      onChange={_onChange}
      placeholder={t(placeholder || "Kirjoita hakeaksesi")}
      noResultsMessage={loadError ? t("Haku epäonnistui!") : loading ? t(placeholder || "Haetaan...") : t(placeholder || "Ei tuloksia")}
      search
      clearable
    />
  );


  return (
    <Form.Input
      key={id}
      id={name}
      type={schema.type === "string" ? undefined : schema.type}
      label={t(label || schema.title || id)}
      required={required}
      autoFocus={autofocus}

      disabled={disabled || readonly}
      name={name}
      {...semanticProps}
      error={Boolean(rawErrors.length)}
      placeholder={t(placeholder || "Kirjoita hakeaksesi")}
      value={value || value === 0 ? value : ""}
      onChange={_onChange}
      onBlur={_onBlur}
      onFocus={_onFocus}
    />
  );
}

RelatedPermitWidget.defaultProps = {
  options: {
    semantic: {
      fluid: true,
      inverted: false,
    },
  },
};

RelatedPermitWidget.propTypes = {
  options: PropTypes.object,
};

export default RelatedPermitWidget;
